// implements src\views\mixins\session-action.js

// import { useTypedStore } from '@/store';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';

export function useSessionAction() {
  // const store = useTypedStore();
  const store = useStore();

  const onSessionUnlock = ref(() => {});

  const significantActionsSeconds = computed(() => store.getters['session/significantActionsSeconds']);

  const significantActionsSecondsWatchHandle = watch(significantActionsSeconds, (newVal, oldVal) => {
    if (oldVal === 0 && newVal) {
      onSessionUnlock.value();
    }
  });

  return {
    onSessionUnlock,
    significantActionsSeconds,
    significantActionsSecondsWatchHandle,
  };
}

